export default {
  reservations: 'Varaukset',
  activated: 'Käytössä',
  deactivated: 'Pois käytöstä',
  reservations_deactivated: 'Varaukset ovat pois käytöstä.',
  tabs: {
    general: 'Yleiset',
    information: 'Tiedot',
  },
  sections: {
    notifications_confirmation: 'Ilmoitukset ja vahvistus',
    notifications_confirmation_description: 'Miten vieraat varaavat ja miten saat ilmoituksen.',
    who_can_book: 'Kuka voi varata',
    who_can_book_description: 'Seurueen kokorajat verkkovarauksille.',
    when_how_bookings_work: 'Milloin ja miten varaukset toimivat',
    when_how_bookings_work_description:
      'Ajoitus-, kesto- ja kapasiteettisäännöt, jotka määrittävät vieraille näkyvät ajat.',
  },
  google: {
    label: 'Näytä varaukset Googlessa',
  },
  storefront: {
    label: 'Näytä varaukset Storefrontissa',
  },
  auto_confirm: {
    label: 'Vahvista varaukset automaattisesti',
  },
  email: {
    label: 'Sähköposti saapuville varauksille',
    add: 'Lisää sähköposti',
    placeholder: 'Anna sähköposti',
    required: 'Lisää vähintään yksi sähköposti vastaanottaaksesi uusia varauksia.',
    invalid: 'Anna kelvollinen sähköpostiosoite.',
  },
  has_whatsapp_phone_number: {
    label: 'Lähetä ilmoitukset WhatsAppin kautta',
  },
  whatsapp_phone_number: {
    label: 'WhatsApp-numero',
    add: 'Lisää puhelinnumero',
  },
  party_size: {
    label: 'Sallittu seurueen koko per varaus',
    min_label: 'Väh.',
    max_label: 'Enint.',
    to: '–',
    guests: 'vierasta',
    helper: 'Kuinka pieni tai suuri varaus voi olla. Vieras voi varata vain tämän rajan sisällä olevan henkilömäärän.',
    warning:
      'Google hyväksyy varaukset vain 2–16 hengelle. Tämän väliin kuulumattomat varaukset toimivat silti Storefrontissasi, mutta eivät näy Googlessa.',
    warning_min: 'Google suosittelee vähintään 2 hengen varauksia.',
    warning_max: 'Google suosittelee enintään 16 hengen varauksia.',
    min_note: 'Google ei tarjoa varauksia pienemmille seurueille kuin {{count}}.',
  },
  time_slot: {
    label: 'Varausväli',
    helper: 'Vieraat voivat varata tämän minuuttimäärän välein.',
    extra: 'esim. {{example}}',
  },
  reservation_gap: {
    label: 'Varausraja ennen sulkemista',
    helper: 'Viimeinen hetki, jolloin vieras voi aloittaa varauksen, laskettuna sulkemisajastasi taaksepäin.',
    helper_link: 'Näytä varausajat',
    extra: 'esim. suljet klo 22:00, raja {{example}} min → viimeinen varattava alkamisaika on {{example}}',
  },
  reservation_notice_period: {
    label: 'Vähimmäisilmoitusaika',
    helper: 'Aikaisin ajankohta, jolloin vieras voi varata ennen saapumisaikaansa.',
    extra: 'esim. varaa viimeistään {{example}}, kun saapuminen on klo 18:00',
  },
  opening_times: {
    label: 'Aukioloajat',
  },
  total_seats: {
    label: 'Vieraiden kokonaiskapasiteetti',
    helper:
      'Enimmäismäärä vieraita (ei pöytiä), jotka voidaan istuttaa samaan aikaan. Laske yksittäiset paikat – esim. 5 x 4 hengen pöytää = 20.',
  },
  capacity_explainer: {
    title: 'Näin kapasiteetti toimii',
    body: 'Tämä on vieraiden määrä, jonka voit istuttaa kerralla. Jokainen varaus varaa paikkoja sen keston ajaksi ja vapauttaa ne sitten seuraaville vieraille. Järjestelmä pitää riittävästi tilaa kaikille varanneille, jotta ylivarauksia ei synny.',
    body_example:
      'Esimerkki: 20 paikalla voit ottaa 12 hengen varauksen klo 19:00 ja 10 hengen varauksen klo 21:00, koska ensimmäisen seurueen paikat vapautuvat ennen seuraavan saapumista.',
  },
  note: {
    label: 'Huomio',
  },
  grace_period: {
    label: 'Siirtymäaika',
    helper: 'Kuinka kauan pöytää pidetään varattuna varauksen alkamisajan jälkeen.',
    tooltip:
      'Ylimääräinen puskuri, joka lisätään varauksen keston jälkeen ennen kuin pöytä tarjotaan uudelleen (esim. pöydän tyhjennystä ja valmistelua varten).',
    extra: 'esim. pidetään varattuna klo {{example}} asti klo 18:00 varaukselle',
    placeholder: 'Syötä siirtymäaika',
  },
  information: {
    rules: {
      label: 'Pöytäsi varataan:',
      add: 'Lisää',
    },
  },
  reservation_duration: {
    label: 'Varauksen kesto',
    helper: 'Kuinka kauan kukin pöytä on varattuna per varaus.',
    tooltip:
      'Kuinka kauan pöytä pidetään varattuna kutakin varausta kohden. Tätä käytetään laskemaan, milloin pöytä vapautuu seuraavalle vieraalle.',
    extra: 'esim. 18:00 – {{example}}',
    minutes: '{{ count }} minuuttia',
    hour_one: '{{ count }} tunti',
    hour_other: '{{ count }} tuntia',
  },
  buttons: {
    save: 'Tallenna',
    activate: 'Ota käyttöön',
    deactivate: 'Poista käytöstä',
  },
  success_messages: {
    updated: 'Päivitys onnistui',
    saving_successful:
      'Päivitys onnistui. Huomaa, että Googlella voi kestää jopa 24 tuntia ennen kuin muutokset näkyvät.',
  },
  error_messages: {
    invalid_phone_number: 'Virheellinen puhelinnumero',
    saving_unsuccessful: 'Virhe muutosten tallentamisessa. Yritä uudelleen.',
    enter_correct_email: 'Anna oikea sähköpostiosoite.',
  },
};
